import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('customerMasterDataStore')
@observer
class PermissionManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { customerMasterDataStore,dataType, record, location } = this.props
    const { isFetching } = customerMasterDataStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm dataType={dataType} record={record} location={location} />
          <SearchResult dataType={dataType} record={record} />
        </div>
      </Spin>
    );
  }
}
export default PermissionManagement;
